<span class="content-type-badge d-inline-flex align-items-center gap-1 fs-xsmall fw-800" [class.live-stream]="type === 'live-stream'">
  <gray-icon style="width: 14px;" [icon]="type === 'live-stream' ? 'stream' : 'play'"></gray-icon>
  {{(type === 'live-stream' ? 'content.type_live_stream' : 'content.type_video')|translate}}
</span>
